import React from 'react'

export default [
  {
    'name': 'cluster',
    'data': [
      <div key={'1'}>
        <h1>HD TFT INSTRUMENT CLUSTER</h1>
        <p>The reconfigurable, virtual display offers a choice of three different display themes, including full map,
          but as befits a true sports car, the default mode is characterised by the large central rev-counter.</p>
      </div>]
  }, {
    'name': 'seats',
    'data': [
      <div key={'1'}>
        <h1>LIGHTWEIGHT SLIMLINE SEATS</h1>
        <p>The ergonomically-optimised form offers outstanding comfort, enhanced by heating and cooling options. Rich
          materials such as Windsor leather add further luxury, complemented by beautiful monogram stitching. Core and
          R-Dynamic models come as standard with the pure lines of the Sport seat. The Performance seat, offering
          greater shoulder support, is standard on the R and First Edition models, with the latter featuring embossed
          Jaguar Leaper motifs in the headrests.</p>
      </div>]
  }, {
    'name': 'trim',
    'data': [
      <div key={'1'}>
        <h1>DOOR TRIM</h1>
        <p>The leather trim covering the door panels now features a beautifully-crafted monogram stitch pattern,
          inspired by Jaguar’s rich heritage. This complements the monogram stitching applied to the slimline seats.</p>
      </div>]
  }, {
    'name': 'infotainment',
    'data': [
      <div key={'1'}>
        <h1>INFOTAINMENT SYSTEM</h1>
        <p>New F-TYPE features the responsive, intuitive Touch Pro infotainment system with Apple CarPlay and Android
          Auto as standard and software-over-the-air functionality to enable future software updates to be made at the
          customer’s convenience without having to visit a Retailer.</p>
      </div>]
  }, {
    'name': 'meridian',
    'data': [
      <div key={'1'}>
        <h1>MERIDIAN AUDIO</h1>
        <p>As well as seamless connectivity, the Touch Pro system delivers outstanding audio performance too, with a
          choice of two systems developed specifically for the new F-TYPE with experts from world-renowned British firm
          Meridian. The standard-fit and the optional Surround Sound system deliver exceptionally clear, crisp sound
          optimised for both driver and passenger.</p>
      </div>]
  }, {
    'name': 'detailing',
    'data': [

      <div key={'1'}>
        <h1>1935 DETAILING</h1>
        <p>The interior’s craftsmanship and attention to detail is exemplified by the discreet ‘Jaguar Est. 1935
          markings’ found on the seat belt guides and the glovebox release button bezel. This subtle reference signifies
          the year when the Jaguar name was first used by company founder Sir William Lyons to brand one of his
          beautiful, fast cars.</p>
      </div>]
  }, {
    'name': 'bonnet',
    'data': [
      <div key={'1'}>
        <h1>NEW CLAMSHELL BONNET AND VENTS</h1>
        <p>Sweeping elegantly back from the super-slim Pixel LED headlights* is a new clamshell bonnet design. The
          surfaces are softer and more organic than before, as if liquid metal, inspired by the beautiful flowing
          forms of models from Jaguar’s rich history, such as the C-type and D-type. The air vents are positioned
          further
          forward than before for greater efficiency, and blend perfectly into the sculpted aluminium that surrounds
          them.</p>
        <p>*Exclusive to the new F-TYPE R</p>
      </div>]
  }, {
    'name': 'headlights',
    'data': [
      <div key={'1'}>
        <h1>SUPER-SLIM PIXEL LED HEADLIGHTS</h1>
        <p>The horizontal form with updated signature ‘Calligraphy’ J daytime running lights and sweeping direction
          indicators exaggerate the car’s visual width. Individual LEDs can be switched off or dimmed to produce a high
          beam which masks out other vehicles, allowing excellent illumination of the road ahead without dazzling other
          drivers.</p>
      </div>]
  }, {
    'name': 'grille',
    'data': [
      <div key={'1'}>
        <h1>NEW GRILLE</h1>
        <p>The subtly enlarged grille accentuates the car’s visual presence and now features the F-TYPE word marque.
          Wider and deeper than before, it features a new hexagonal mesh pattern with each cell in gloss black at the
          front and satin black on the inner surfaces. The surround is Noble Chrome, or gloss black when the Black
          Design pack is specified.</p>
      </div>]
  }, {
    'name': 'wheels',
    'data': [
      <div key={'1'}>
        <h1>NEW 20-INCH WHEEL DESIGNS</h1>
        <p>R models gain the new 10-spoke, 20-inch wheels in Gloss Black with contrast Diamond-Turned finish. First
          Edition models feature new 5-spoke, 20-inch wheels in Gloss Technical Grey with contrast Diamond-Turned
          finish.</p>
      </div>]
  }, {
    'name': 'bumper',
    'data': [
      <div key={'1'}>
        <h1>NEW FRONT BUMPERS</h1>
        <p>Bolder surfaces with discreet signature graphics to enhance the overall design and provide greater
          differentiation across the range. For core models, the look is clean and sculptural. R-Dynamic models gain
          layered J aero-blades which well as referencing a racing influence. R models feature gloss black bezels around
          the apertures for an even more assertive appearance.</p>
      </div>]
  },
  {
    'name': 'suspension',
    'data': [
      <div key={'1'}>
        <h1>SUSPENSION</h1>
        <p>Aluminium double wishbone front and rear suspension and state-of-the-art electric power-assisted steering are
          fundamental to the new F-TYPE’s outstanding ride and handling. R models gain new adaptive dampers, new
          anti-roll bars, stiffer rear knuckles and upper ball joints, and 10mm-wider tyres front and rear for even
          greater precision and control.</p>
      </div>]
  }, {
    'name': 'body',
    'data': [
      <div key={'1'}>
        <h1>LIGHTWEIGHT ALUMINIUM BODY STRUCTURE</h1>
        <p>F-TYPE's breadth of performance is unrivalled in the sports car segment, and demonstrates the inherent
          strength and stiffness engineered into the lightweight aluminium body structure from the start to deliver the
          high levels of agility, responsiveness and refinement demanded.</p>
      </div>]
  }, {
    'name': 'rearlights',
    'data': [
      <div key={'1'}>
        <h1>SLIMLINE REAR LIGHTS</h1>
        <p>The slender LED rear light clusters feature a bold, ‘Chicane’ graphic inspired by the all-electric I-PACE.
          Beneath is a fine pinstripe detail and, like the headlights, an intricate pattern formed of the Jaguar
          heritage monogram.</p>
      </div>]
  }, {
    'name': 'exhaust',
    'data': [
      <div key={'1'}>
        <h1>ACTIVE EXHAUST SYSTEMS</h1>
        <p>Each engine is equipped with an active exhaust system, switchable as an option or as standard. Customers who
          choose either the 450PS or 575PS supercharged V8 benefit from the new Quiet Start function, which ensures a
          more subtle, refined sound – the electrically-actuated bypass valves in the rear silencer remain closed until
          they automatically open up under load, releasing the signature roar fundamental to the F-TYPE driving
          experience. If desired, Quiet Start can be over-ridden. The distinctive crackle and pop on the overrun
          synonymous with F-TYPE, remains, with sounds meticulously tuned to suit the distinctive character of each
          model.</p>
      </div>]
  }, {
    'name': 'engine',
    'data': [
      <div key={'1'}>
        <h1>POWERFUL, REFINED ENGINES</h1>
        <p>The range includes four-, six- and eight-cylinder options* with outputs from 300PS to 575PS – a breadth of
          choice unrivalled in its segment. All are matched to eight-speed Quickshift transmissions with full manual
          control using either the SportShift gear selector or the steering wheel-mounted paddles:
        </p>
        <p>300PS 2.0-litre I4 turbocharged; rear-wheel drive<br/>
          380PS 3.0-litre V6 supercharged; rear- / all-wheel drive<br/>
          450PS 5.0-litre V8; supercharged; rear- / all-wheel drive<br/>
          575PS 5.0-litre V8; supercharged; all-wheel drive</p>
        <p>* Market-dependant</p>
      </div>]
  }
]
